import { BookingDTO } from "../../apiclient/ApiDtos";
import { SubFsmBuilder } from "little-fsm";
import { BookingConfirmationFsmContext } from "./BookingConfirmationFsmContext";

export type BookingConfirmationFsmScheme = {
    context: BookingConfirmationFsmContext,
    substates: [
        'awaiting',
        'showing_confirmation_error',
        'showing_confirmation_details', 
        'confirming_restart'
    ],
    events: {    
        "back": {},
        "restart_confirmed": {},
        "restart_cancelled": {},
        "confirmation_failed": {errorMessage:string},
        "confirmation_completed": {booking:BookingDTO}
    }
}

// just simple identity function
const $I = (x: any) => x;

export function bookingConfirmationSubFsmBuilder() : SubFsmBuilder<BookingConfirmationFsmScheme> {
    let subBuilder = new SubFsmBuilder<BookingConfirmationFsmScheme>(); 

    subBuilder.entrySubstate('awaiting')        

    subBuilder.substate("awaiting")
        .transition('confirmation_completed', 'showing_confirmation_details', (context, event) => 
            new BookingConfirmationFsmContext(context.tenativeBooking, event.booking))
        .transition('confirmation_failed', 'showing_confirmation_error', (context, event) => 
            new BookingConfirmationFsmContext(context.tenativeBooking, null, event.errorMessage))
        //.transition('back', 'back_navigation_confirming', (context, event) => context);
    
    subBuilder.substate("showing_confirmation_details")
        .transition('back', 'confirming_restart', (context, event) => context);

    subBuilder.substate("showing_confirmation_error")
        .transition('confirmation_completed', 'showing_confirmation_details', (context, event) => 
            new BookingConfirmationFsmContext(context.tenativeBooking, event.booking))
        .transition('back', 'confirming_restart', (context, event) => context);

    subBuilder.substate('confirming_restart')
        .transition('restart_cancelled', "showing_confirmation_details", (context, event) => context)
        .completion('restart_confirmed', $I);  

    return subBuilder;
}